const SidebarLink = ({
  icon,
  children,
  Tag = 'span',
  href = false,
  target = '_self',
}) => {
  return (
    <div className="mb-2">
      {href ? (
        <a
          className="flex items-center justify-start rounded-md bg-accent-300 py-3 px-4 hover:bg-accent-500"
          href={href}
          target={target}
          rel={target === '_blank' ? 'nofollow' : ''}
        >
          <span className="mr-4 block text-2xl text-primary-500">{icon}</span>
          <Tag className="block font-medium uppercase">{children}</Tag>
        </a>
      ) : (
        <div className="flex items-center justify-start rounded-md bg-white/25 py-3 px-4">
          <span className="mr-4 block text-2xl text-primary-500">{icon}</span>
          <Tag className="block font-medium uppercase">{children}</Tag>
        </div>
      )}
    </div>
  )
}
export default SidebarLink
